import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useMeContext } from '~/modules/me/useMeContext';
import { useProjectResourceAllocationPermissions } from '~/modules/common/hooks/project/useProjectResourceAllocationPermissions';
import { TaskEstimateRowContext } from './TaskEstimateRowContext';

const TaskEstimateRowContextProvider = ({
  canEditTasks,
  canViewCost,
  dialogProps,
  resourceEstimate,
  task,
  children
}) => {
  const {
    featureFlags: {
      isPsaRmpEnhancedProjectManagerPersonaEnabled,
      isPsaPrpTcop2Enabled
    },
    isRoleCostMode
  } = useMeContext();

  const {
    canViewResourceAllocation,
    canEditResourceAllocation
  } = useProjectResourceAllocationPermissions(
    task?.project?.resourceAllocationActions
  );

  const canEditTaskAllocations = isPsaRmpEnhancedProjectManagerPersonaEnabled
    ? Boolean(canViewResourceAllocation && canEditTasks)
    : Boolean(canEditTasks);

  const canViewRoleCost = Boolean(canViewCost && !isPsaPrpTcop2Enabled);
  const isUserCostMode = Boolean(
    isPsaRmpEnhancedProjectManagerPersonaEnabled && !isRoleCostMode
  );

  const value = useMemo(
    () => ({
      canViewCost: Boolean(canViewCost),
      canViewRoleCost,
      isUserCostMode,
      canEditTasks,
      canEditTaskAllocations,
      dialogProps,
      resourceEstimate,
      task,
      canViewResourceAllocation,
      canEditResourceAllocation
    }),
    [
      canEditTasks,
      canViewCost,
      canViewRoleCost,
      isUserCostMode,
      dialogProps,
      resourceEstimate,
      task,
      canViewResourceAllocation,
      canEditResourceAllocation,
      canEditTaskAllocations
    ]
  );

  return (
    <TaskEstimateRowContext.Provider value={value}>
      {children}
    </TaskEstimateRowContext.Provider>
  );
};

TaskEstimateRowContextProvider.propTypes = {
  children: PropTypes.node,
  canEditTasks: PropTypes.bool,
  canViewCost: PropTypes.bool,
  dialogProps: PropTypes.object,
  resourceEstimate: PropTypes.object,
  task: PropTypes.object
};

export default TaskEstimateRowContextProvider;
